function getScrollbarWidth() {
    // Create a temporary container with scroll
    const scrollDiv = document.createElement('div');
    // Apply styles to force a scrollbar
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px'; // move off-screen
    document.body.appendChild(scrollDiv);
    // Calculate the width difference
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    // Clean up
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
export const SCROLLBAR_WIDTH = { value: getScrollbarWidth() };
if (!SCROLLBAR_WIDTH.value) {
    document.addEventListener('DOMContentLoaded', () => {
        SCROLLBAR_WIDTH.value = getScrollbarWidth();
    });
}
